require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2012-03-01-march-2012.json") })
        }
      }, "path---articles-2012-03-01-march-2012");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2012-03-01-march-2012!./.cache/json/articles-2012-03-01-march-2012.json
// module id = 618
// module chunks = 231608221292675